export const handleErrorFetchingCredentials = (error: any): void => {
  console.error('An error occurred while fetching account credentials:', error);
};
